var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.778,
    height: 101.778,
    viewBox: "0 0 101.778 101.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#BDA770;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.815,17.971V8.482A8.492,8.492,0,0,0,76.334,0H8.482A8.492,8.492,0,0,0,0,8.482V45.8a8.465,8.465,0,0,0,7.606,8.394l6.376,16.552a8.484,8.484,0,0,0,10.964,4.865L64.765,60.273a24.522,24.522,0,0,0,2.113,21.773l.975,1.558v16.478a1.7,1.7,0,0,0,1.7,1.7h30.533a1.7,1.7,0,0,0,1.7-1.7V44.089a22.2,22.2,0,0,0-6.5-15.636Zm0,10.145L89.964,41.48a5.089,5.089,0,0,1-2.921,6.577L84.1,49.193a8.484,8.484,0,0,0,.716-3.393ZM3.393,45.8V8.482A5.09,5.09,0,0,1,8.482,3.393H76.334a5.09,5.09,0,0,1,5.089,5.089V19.263h-.015l.015.039V45.8a5.148,5.148,0,0,1-.115.879L65.769,31.139A9.05,9.05,0,0,0,52.708,43.654l6.624,7.235H8.482A5.09,5.09,0,0,1,3.393,45.8Zm21.731,8.482L13.062,58.926l-1.785-4.644Zm-1.4,18.164a5.089,5.089,0,0,1-6.578-2.919l-2.862-7.442,20.249-7.8v-.01H62.441l2.2,2.4Zm74.659,25.94H71.245V84.815H98.386Zm0-16.963H70.49l-.736-1.176a21.153,21.153,0,0,1-.43-21.725,1.7,1.7,0,0,0-.222-1.988L55.2,41.369a5.657,5.657,0,0,1,8.169-7.824L90.4,60.57l2.4-2.4L86.523,51.9l1.74-.679a8.482,8.482,0,0,0,4.863-10.959L87.386,25.349l5.5,5.507a18.785,18.785,0,0,1,5.5,13.233Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.053,79.463a4.41,4.41,0,0,0,4.41-4.41V66.91a4.41,4.41,0,0,0-4.41-4.41H66.91a4.41,4.41,0,0,0-4.41,4.41v8.142a4.41,4.41,0,0,0,4.41,4.41Zm-9.16-4.41V72.678h3.393V69.285H65.893V66.91a1.018,1.018,0,0,1,1.018-1.018h8.142A1.018,1.018,0,0,1,76.07,66.91v2.375H72.678v3.393H76.07v2.375a1.018,1.018,0,0,1-1.018,1.018H66.91A1.018,1.018,0,0,1,65.893,75.053Zm0,0",
    transform: "translate(-55.715 -55.715)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.125,265.625H84.91v3.393H78.125Zm0,0",
    transform: "translate(-69.643 -236.788)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.125,359.375H84.91v3.393H78.125Zm0,0",
    transform: "translate(-69.643 -320.36)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M359.375,359.375h6.785v3.393h-6.785Zm0,0",
    transform: "translate(-320.36 -320.36)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M171.875,265.625h6.785v3.393h-6.785Zm0,0",
    transform: "translate(-153.216 -236.788)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M265.625,265.625h6.785v3.393h-6.785Zm0,0",
    transform: "translate(-236.788 -236.788)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M359.375,265.625h6.785v3.393h-6.785Zm0,0",
    transform: "translate(-320.36 -236.788)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M656.25,78.125h3.393v5.089H656.25Zm0,0",
    transform: "translate(-585.005 -69.643)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M593.75,78.125h3.393v5.089H593.75Zm0,0",
    transform: "translate(-529.29 -69.643)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M531.25,78.125h3.393v5.089H531.25Zm0,0",
    transform: "translate(-473.576 -69.643)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M468.75,78.125h3.393v5.089H468.75Zm0,0",
    transform: "translate(-417.861 -69.643)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M687.5,812.5h3.393v3.393H687.5Zm0,0",
    transform: "translate(-612.862 -724.292)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.46d457987e932e05427927a64ed490ec.svg";
export { ForwardRef as ReactComponent };